import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {withRouter} from "react-router-dom";
import LabelIcon from '../../../list-of-groups/components/label/components/label-icon';
import {sharedWordRemove, translate} from '../../../../../../utils';
import SharingPreview from '../../../../../../components/sharing-preview';
import NewLabelsLoading from '../../../list-of-groups/components/new-labels-loading';
import Input from '../../../../../../components/input';
import ButtonWithIcon from '../../../../../../components/button-with-icon';
import {
	createLabelToAttach,
	labelStateUpdating,
	postCreateLabelToAttach
} from '../../../../../../../actions/contactsGroupItemActions';
import {getSharingDetailsPopup} from '../../../../../../../actions/sharingDetailsActions';
import {msgBar} from '../../../../../../../actions/msgBarActions';
import {addToOtherLabel as setAddToOtherLabel} from '../../../../../../../actions/contactDetailsActions';
import {putLabelToAdd} from '../../../../../../../actions/contactActions';
import Button from '../../../../../../components/button';
import Icon from '../../../../../../components/icon';
import Loader from "../../../../../../components/sprite/components/loader";
import './index.css';


function SelectOneLabelPopup ({history}) {

	const { t } = useTranslation();

	const [createLabel, setCreateLabel] = useState(false);
	const [labelNameValue, setLabelNameValue] = useState("");
	const [currentSelectedLabel, setCurrentSelectedLabel] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [scrollTop, setScrollTop] = useState(0);
	const [viewportHeight, setViewportHeight] = useState(0);
	const [filteredLabels, setFilteredLabels] = useState(null);

	const sharingDetailsPopup = useSelector( state => state.sharingDetailsReducer.getSharingDetailsPopup);
	const gmailAddOnMsgBar = useSelector( state => state.msgBarReducer.gmailAddOnMsgBar);
	const addToOtherLabel = useSelector( state => state.contactDetailsReducer.addToOtherLabel);
	const findLabels = useSelector( state => state.contactsGroupItemReducer.findLabels);
	const isNewLabelsLoading = useSelector( state => state.contactsGroupItemReducer.isNewLabelsLoading);

	const dispatch = useDispatch();

	const rowHeight = 32;
	const amountRowsBuffered = 2;

	let checkGmailAddon = sharingDetailsPopup[1].includes('gmail');

	useEffect(() => {
		if(document.querySelector('.gmail-select-one-label-popup')) {
			setViewportHeight(document.querySelector('.gmail-select-one-label-popup .modal-body').clientHeight);
		} else {
			setViewportHeight(document.querySelector('.select-one-label-popup .modal-body').clientHeight);
		}
	}, []);

	useEffect(() => {
		if(findLabels){
			setFilteredLabels(findLabels.contactsGroups.filter(item => item.permission !== 'READ_ONLY').map((item, index) => {
				return (
					{
						...item,
						position: index + 1
					}
				)
			}))
		}
	},[findLabels]);

	let totalRows = filteredLabels ? filteredLabels.length : 0;

	let indexStart = Math.max(
		Math.floor(scrollTop / rowHeight) - amountRowsBuffered,
		0
	);

	let indexEnd = Math.min(
		Math.ceil((scrollTop + viewportHeight) / rowHeight - 1) +
		amountRowsBuffered,
		totalRows - 1
	);

	const handleSelectLabel = (e) => {

		let exists = currentSelectedLabel.some(item => e.currentTarget.dataset.id === item.id );

		if(!exists){
			setCurrentSelectedLabel([
				...currentSelectedLabel,
				{
					id: e.currentTarget.dataset.id,
					name: e.currentTarget.dataset.name,
					status: e.currentTarget.dataset.status,
					permission: e.currentTarget.dataset.permission,
					ownerId: e.currentTarget.dataset.ownerId
				}
			]);
		} else {
			setCurrentSelectedLabel(currentSelectedLabel.filter(item => e.currentTarget.dataset.id !== item.id))
		}

		setCreateLabel(false);
	};

	const createLabelHandler = () => {
		setCreateLabel(true);
		setCurrentSelectedLabel(null);
	};

	const changeHandler = (e) => {

		setLabelNameValue(e.currentTarget.value);

		if(document.querySelector('.select-one-label-popup')){
			if(document.querySelector('.select-one-label-popup .labelName').classList.contains('is-invalid')){
				document.querySelector('.select-one-label-popup .labelName').classList.remove('is-invalid');
			}
		} else if (document.querySelector('.gmail-select-one-label-popup')) {
			if(document.querySelector('.gmail-select-one-label-popup .labelName').classList.contains('is-invalid')){
				document.querySelector('.gmail-select-one-label-popup .labelName').classList.remove('is-invalid');
			}
		} else {
			// do nothing
		}
	};

	const confirmLabelCreationHandler = (e) => {
		e.preventDefault();
		if(labelNameValue.trim()){
			dispatch(postCreateLabelToAttach(labelNameValue));
			setCreateLabel(false);
			setLabelNameValue('');
		} else {
			if(document.querySelector('.select-one-label-popup')){
				if(document.querySelector('.select-one-label-popup .labelName').classList.contains('is-invalid') === false){
					document.querySelector('.select-one-label-popup .labelName').classList.add('is-invalid');
				}
			} else if (document.querySelector('.gmail-select-one-label-popup')) {
				if(document.querySelector('.gmail-select-one-label-popup .labelName').classList.contains('is-invalid') === false){
					document.querySelector('.gmail-select-one-label-popup .labelName').classList.add('is-invalid');
				}
			} else {
				// do nothing
			}
		}
	};

	const loadButton = () => {
		if(isLoading){
			return (
				<Button type="submit" className="btn-primary" disabled={true}>
					<Icon animated={'pulse'} name="spinner"/>
				</Button>
			)
		} else if (createLabel) {
			return <Button type="submit" className="btn-primary" disabled={!labelNameValue.trim()}>Save and add to label</Button>
		} else {
			return <Button type="submit" className="btn-primary" disabled={!currentSelectedLabel}>{t("addbtnText2")}</Button>
		}
	};

	const update = (e) => {
		setScrollTop(e.target.scrollTop);
	};

	const proceed = (e) => {

		e.preventDefault();

		if(createLabel === true) {
			if(labelNameValue.trim()){
				dispatch(createLabelToAttach(labelNameValue, sharingDetailsPopup, history));
				setCreateLabel(false);
				setLabelNameValue('');
			} else {
				document.querySelector('.select-one-label-popup .labelName').classList.add('is-invalid');
			}
		} else {

			setIsLoading(true);

			if(currentSelectedLabel !== null) {

				dispatch(labelStateUpdating(setCurrentSelectedLabel.id));

				/*
				* @param 1 @Array: Current selected labels,
				* @param 2 @Array: Current selected contacts,
				* @param 3 @Object: Label data selected after contacts add,
				* @param 4 @String: Label name used for the msgBar
				* @param 5 @Boolean: To know if that's a direct contact share, so the contact name is displayed on msgBar
				* @param 6 @Boolean: To know if the popup is opened from the share button of a searched contact
				* @param 7 @Boolean: FinishFirstLabelSharing
				* @param 8 @String: OwnerId
				* @param 9 @Boolean: Not suggest to share after attachment to a label
				* */

				let readOnlyLabel = currentSelectedLabel.some( item => item.permission === 'READ_ONLY');

				if(readOnlyLabel){
					let labelName = currentSelectedLabel.name;
					labelName = labelName.replace("(Shared)",'');
					labelName = labelName.bold();

					dispatch(msgBar(['error', translate("msgBarErrorText3").replace("{{labelName}}",labelName)]));
					dispatch(getSharingDetailsPopup([]));
					dispatch(labelStateUpdating(null));

					/*
					* If come from Contact details popup
					* */

					if(
						sharingDetailsPopup[1] === 'contact_details'
						&& addToOtherLabel
					){
						dispatch(setAddToOtherLabel(false));
					}
				} else {
					if(gmailAddOnMsgBar.length > 0) {
						let labelName = currentSelectedLabel.name;
						labelName = labelName.replace("(Shared)",'');
						labelName = labelName.bold();
						dispatch(gmailAddOnMsgBar(['error', translate("msgBarErrorText3").replace("{{labelName}}",labelName)]))
						setIsLoading(false);
						dispatch(labelStateUpdating(null));
					} else {
						dispatch(putLabelToAdd(
							currentSelectedLabel,
							sharingDetailsPopup[2],
							sharingDetailsPopup[5] === 'fromAddToLabelButton' ? false : currentSelectedLabel,
							currentSelectedLabel[0].name,
							sharingDetailsPopup[3],
							sharingDetailsPopup[4],
							null,
							currentSelectedLabel[0].ownerId,
							history
						));
					}
				}

			}
		}
	};

	return (
		<div className={checkGmailAddon ? "gmail-select-one-label-popup" : "select-one-label-popup"}>
			<form className={gmailAddOnMsgBar.length > 0 ? 'gmail-select-one-label-popup_form_error' : null} method="post" onSubmit={proceed}>
				<div className="modal-header justify-content-start">
					<h2 className="m-0 mr-5">{t("addbtnText1")}.</h2>
				</div>
				<div className="modal-body" onScroll={ update }>
					<div
						style={{
							position: 'relative',
							height: rowHeight * totalRows,
							overflowX: 'hidden'
						}}
					>
						{
							filteredLabels !== null
							?
								filteredLabels.length > 0
								?
									filteredLabels.slice(indexStart, indexEnd + 1).map(filteredLabel => {

										/*
										* If that's not from a research the selected label is excluded
										* */

										return (
											<div
												key={filteredLabel.id}
												className="select-one-label-popup__label custom-control custom-checkbox"
												style={{
													height: rowHeight,
													top: filteredLabel.position * rowHeight - rowHeight
												}}
											>
												<input
													type="checkbox"
													data-id={filteredLabel.id}
													data-name={filteredLabel.name}
													data-status={filteredLabel.status}
													data-owner-id={filteredLabel.ownerId}
													data-permission={filteredLabel.permission}
													checked={currentSelectedLabel.some( item => item.id === filteredLabel.id)}
													onChange={handleSelectLabel}
													className="custom-control-input"
													id={`label-checkbox-${filteredLabel.id}`}
													name={"label"}
												/>
												<label className="custom-control-label flex-shrink-0"
													   htmlFor={`label-checkbox-${filteredLabel.id}`}>
													<LabelIcon type={filteredLabel.type}/>
													{sharedWordRemove(filteredLabel.name)} ({filteredLabel.nbOfContact})
												</label>
												<SharingPreview
													permission={filteredLabel.permission}
													labelId={filteredLabel.id}
													collaborators={filteredLabel.sharingPreview}
													sharingNumber={filteredLabel.sharingNumber}
													status={filteredLabel.status}
												/>
											</div>
										)
									})
								:
									<p>{t("textNoContactListsFound")}</p>
							:
								<Loader/>
						}
					</div>
				</div>
				{
					gmailAddOnMsgBar.length > 0 &&
					<div className="gmail-add-on-msg-bar-error" dangerouslySetInnerHTML={{__html: gmailAddOnMsgBar[1]}}/>
				}
				{ isNewLabelsLoading && <NewLabelsLoading labels={findLabels}/>}
				<div className="modal-footer">
					{
						createLabel
							?
							<div className="d-flex align-items-center">
								<Input type="text" className="form-control labelName mr-2" onChange={changeHandler} placeholder={t("labelName")}/>
								<ButtonWithIcon className="text-nowrap createBtn" disabled={!labelNameValue.trim()} onClick={confirmLabelCreationHandler}>
									Save without adding
								</ButtonWithIcon>
							</div>
							:
							<ButtonWithIcon className="btn-outline-secondary" onClick={createLabelHandler}>
								<svg className="mr-1" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fillRule="evenodd" clipRule="evenodd" d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM12 18C11.4477 18 11 17.5523 11 17V13H7C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11H11V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H13V17C13 17.5523 12.5523 18 12 18Z" fill="#4CC2F1"/>
								</svg>
								{t("textSharedWithMeLabelCreate")}
							</ButtonWithIcon>
					}
					{loadButton(sharingDetailsPopup[1])}
				</div>
			</form>
		</div>
	);
}

export default withRouter(SelectOneLabelPopup);
